import React from 'react';
import { 
    DashboardIcon, UsersIcon, ContactsIcon, LogoutIcon, 
    TicketIcon, GlobeAltIcon, BriefcaseIcon, BuildingStorefrontIcon, QuestionMarkCircleIcon, BookOpenIcon, TrophyIcon 
} from './DashboardIcons';

interface SidebarProps {
    activeView: 'overview' | 'contacts' | 'users' | 'success-stories' | 'guides' | 'faq' | 'franchises' | 'jobs' | 'delegations' | 'prices';
    setActiveView: (view: 'overview' | 'contacts' | 'users' | 'success-stories' | 'guides' | 'faq' | 'franchises' | 'jobs' | 'delegations' | 'prices') => void;
    onLogout: () => void;
}

const NavLink: React.FC<{
    icon: React.ReactNode;
    label: string;
    isActive: boolean;
    onClick: () => void;
}> = ({ icon, label, isActive, onClick }) => (
    <button
        onClick={onClick}
        className={`w-full flex items-center px-4 py-2.5 transition-colors duration-200 justify-start text-sm ${
            isActive
                ? 'bg-blue-600 text-white rounded-lg shadow-md'
                : 'text-gray-600 hover:bg-gray-200 hover:text-gray-800 rounded-lg'
        }`}
        aria-current={isActive ? 'page' : undefined}
    >
        {icon}
        <span className="mx-3 font-medium">{label}</span>
    </button>
);

export const Sidebar: React.FC<SidebarProps> = ({ activeView, setActiveView, onLogout }) => {
    return (
        <aside className="flex flex-col w-64 h-screen px-5 py-8 overflow-y-auto bg-white border-r rtl:border-r-0 rtl:border-l">
            <a href="#" className="flex items-center space-x-2">
                <img src="images/Logo_multas.eu_2025-06-26_10-41-03.png" alt="Multas.EU Logo" className="h-10" />
                 <h1 className="text-xl font-bold text-blue-600">
                    Multas<span className="text-yellow-500">.EU</span>
                </h1>
            </a>

            <div className="flex flex-col justify-between flex-1 mt-6">
                <nav className="space-y-4">
                    <div>
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase">General</p>
                        <div className="space-y-1 mt-2">
                            <NavLink
                                icon={<DashboardIcon />}
                                label="Dashboard"
                                isActive={activeView === 'overview'}
                                onClick={() => setActiveView('overview')}
                            />
                            <NavLink
                                icon={<ContactsIcon />}
                                label="Contactos"
                                isActive={activeView === 'contacts'}
                                onClick={() => setActiveView('contacts')}
                            />
                            <NavLink
                                icon={<UsersIcon />}
                                label="Usuarios"
                                isActive={activeView === 'users'}
                                onClick={() => setActiveView('users')}
                            />
                        </div>
                    </div>
                     <div>
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase">Gestión de Contenido</p>
                        <div className="space-y-1 mt-2">
                            <NavLink icon={<TrophyIcon />} label="Casos de Éxito" isActive={activeView === 'success-stories'} onClick={() => setActiveView('success-stories')} />
                            <NavLink icon={<BookOpenIcon />} label="Guías de Países" isActive={activeView === 'guides'} onClick={() => setActiveView('guides')} />
                            <NavLink icon={<QuestionMarkCircleIcon />} label="FAQ" isActive={activeView === 'faq'} onClick={() => setActiveView('faq')} />
                        </div>
                    </div>
                     <div>
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase">Gestión de Negocio</p>
                        <div className="space-y-1 mt-2">
                            <NavLink icon={<TicketIcon />} label="Precios" isActive={activeView === 'prices'} onClick={() => setActiveView('prices')} />
                            <NavLink icon={<GlobeAltIcon />} label="Delegaciones" isActive={activeView === 'delegations'} onClick={() => setActiveView('delegations')} />
                            <NavLink icon={<BuildingStorefrontIcon />} label="Franquicias" isActive={activeView === 'franchises'} onClick={() => setActiveView('franchises')} />
                            <NavLink icon={<BriefcaseIcon />} label="Trabajos" isActive={activeView === 'jobs'} onClick={() => setActiveView('jobs')} />
                        </div>
                    </div>
                </nav>

                <div className="mt-6">
                    <button
                        onClick={onLogout}
                        className="w-full flex items-center px-4 py-2.5 text-gray-600 transition-colors duration-200 rounded-lg hover:bg-red-100 hover:text-red-700"
                    >
                        <LogoutIcon />
                        <span className="mx-4 font-medium">Cerrar Sesión</span>
                    </button>
                </div>
            </div>
        </aside>
    );
};